module.exports = __webpack_public_path__ + "img/pro_3.93bea67e.jpg";